import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import { breaks, colors } from '../styles'
import styled from 'styled-components'

import Block from './block'

const BlockGrid = (props) =>  <StaticQuery
    query={graphql`
        query BlocksQuery {
            allMarkdownRemark(
                sort: { order: ASC, fields: [frontmatter___order]},
                filter: {
                    frontmatter: { type: { eq: "block" } }
                }
            ){
                edges{
                    node{
                        frontmatter {
                            text_body
                            button_text
                            button_link
                            color
                        }
                    }
                }
            }
        }
    `}
    render={data => {

        const blocks = data.allMarkdownRemark.edges

        return (
            <main className={props.className}>
                {blocks.map( (block, index) => {
                    return (
                        <Block key={index} {...block.node.frontmatter} />
                    )
                })}
            </main>
        )
    }} 
/>

const StyledBlockGrid = styled(BlockGrid)`
    
    width: 100%;
    margin: .75rem 0;

    ${breaks.tablet(`
        display: flex;
        flex-wrap: wrap;

        & > * {
            min-width: 50%;
            flex: 1;
        }
    `)}    

    &:before, 
    &:after {
        content: '';
        display: block;
        height: .25rem;
        width: 100%;
        background-color: ${colors.blue};
        position: absolute;
        left: 0;
        right: 0;
    }

    &:before {
        top: -.5rem;
    }

    &:after {
        bottom: -.5rem;
    }
`

export default StyledBlockGrid;